var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('GenericListTable',{attrs:{"parentID":this.parentID,"title":"Assets","headers":[
      { text: 'ID', value: 'id' },
      { text: 'Asset Id', value: 'co_assetid' },
      { text: 'Description', value: 'co_description' },
      { text: 'Asset State', value: 'assetstate' },
      { text: 'Asset Note', value: 'assetnote' },
      { text: 'Group code', value: 'co_groupcode' },
      { text: 'Device Name', value: 'devicename' },
      { text: 'Location ID', value: 'co_locationid' } ],"url":"/manifest/assetinfo","apiResponseField":"assetinfolist","onClickRoute":"AssetSingle","onClickParams":_vm.getOnClickParams,"editable":true,"saveUrl":"manifest/assetinfo/bulk?ids_to_update="}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }